<template>
  <div>
    <v-card
      min-width="500px"
      title="DATA FINE FATTURAZIONE"
      style="
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: fit-content;
        row-gap: 30px;
        padding-top: 30px;
        padding-bottom: 30px;
      "
    >
      <div class="warning-text-container">
        <p class="warning-text">
          I colli, le sessioni, i bancali e le chiusure con data uguale o
          precedente a questa data vengono rifiutati.
        </p>
      </div>
      <div
        style="
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          row-gap: 5px;
        "
      >
        <p class="data-corrente">{{ this.formatDate(invoiceEndDate) }}</p>
        <small v-if="this.dataAggiornamento">
          Ultima modifica: {{ this.formatDate(dataAggiornamento)
          }}<span v-if="this.aggiornatore"> da {{ this.aggiornatore }}</span>
        </small>
      </div>
      <div
        style="
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          row-gap: 5px;
        "
      >
        <v-dialog width="375px">
          <template v-slot:activator="{ props }">
            <v-btn
              v-bind="props"
              width="220"
              variant="outlined"
              text="MODIFICA DATA"
              height="48px"
            ></v-btn>
          </template>
          <template v-slot:default="{ isActive }">
            <v-card title="SELEZIONA DATA FINE FATTURAZIONE">
              <div
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
              >
                <v-date-picker
                  style="border: 1px solid #d0d0d0 !important"
                  v-model="this.nuovaData"
                ></v-date-picker>
              </div>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  text="INVIA"
                  @click="
                    () => {
                      isActive.value = false;
                      salvaInvoiceEndDate();
                    }
                  "
                  class="bg-green"
                  variant="outlined"
                ></v-btn>
                <v-btn
                  text="ANNULLA"
                  @click="
                    () => {
                      isActive.value = false;
                    }
                  "
                  variant="outlined"
                ></v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>
      </div>
    </v-card>
  </div>
</template>

<script>
import { useStore } from "vuex";
import Swal from "sweetalert2";
const axios = require("axios");
export default {
  name: "FineFatturazioneCard",

  data() {
    return {
      invoiceEndDate: null,
      dataAggiornamento: null,
      aggiornatore: null,
      nuovaData: null,
    };
  },

  setup() {
    const store = useStore();
    return {
      store,
    };
  },

  mounted() {
    this.fetchInvoiceEndDate();
  },

  methods: {
    formatDate(inputDate) {
      if (inputDate === null) {
        return "nessuna data selezionata";
      }
      // Le stringhe "yyyy-MM-dd" vanno formattate senza passare da Date:
      // new Date("yyyy-MM-dd") è mezzanotte UTC e sposta il giorno nei
      // fusi orari negativi
      if (typeof inputDate === "string" && /^\d{4}-\d{2}-\d{2}/.test(inputDate)) {
        const [year, month, day] = inputDate.slice(0, 10).split("-");
        return `${day} / ${month} / ${year}`;
      }
      const date = new Date(inputDate);

      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();

      return `${day} / ${month} / ${year}`;
    },
    // Il backend si aspetta una LocalDate (yyyy-MM-dd): non inviare un Date
    // grezzo per evitare lo shift di un giorno dovuto al fuso orario
    toIsoDate(date) {
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${year}-${month}-${day}`;
    },
    backendMessage(error) {
      const data = error?.response?.data;
      return typeof data === "string" && data.length > 0 && data.length < 500
        ? data
        : null;
    },
    async fetchInvoiceEndDate() {
      const apiUrl = `${this.$apiBaseUrl}/invoiceEndDate`;
      const bearerToken = this.$keycloak.token;
      const config = {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      };
      try {
        const response = await axios.get(apiUrl, config);
        this.invoiceEndDate = response.data.invoiceEndDate;
        this.dataAggiornamento = response.data.dataAggiornamento;
        this.aggiornatore = response.data.aggiornatore;
      } catch (error) {
        console.error("Error:", error.message);
        Swal.fire({
          title: "ERRORE",
          text:
            this.backendMessage(error) ??
            `C'è stato un errore nel caricamento della data di fine fatturazione`,
          icon: "error",
        });
      }
    },
    async salvaInvoiceEndDate() {
      if (!this.nuovaData) {
        return;
      }
      const conferma = await Swal.fire({
        title: "CONFERMA",
        text: `Impostare la data di fine fatturazione al ${this.formatDate(
          this.nuovaData
        )}? Le operazioni con data uguale o precedente verranno rifiutate.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "CONFERMA",
        cancelButtonText: "ANNULLA",
      });
      if (!conferma.isConfirmed) {
        return;
      }
      const apiUrl = `${this.$apiBaseUrl}/invoiceEndDate/admin`;
      const bearerToken = this.$keycloak.token;
      const config = {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      };
      const payload = {
        invoiceEndDate: this.toIsoDate(this.nuovaData),
      };
      try {
        const response = await axios.put(apiUrl, payload, config);
        this.invoiceEndDate = response.data.invoiceEndDate;
        this.dataAggiornamento = response.data.dataAggiornamento;
        this.aggiornatore = response.data.aggiornatore;
        this.nuovaData = null;
        Swal.fire({
          title: "FINE FATTURAZIONE AGGIORNATA",
          text: `La data di fine fatturazione è stata impostata al ${this.formatDate(
            this.invoiceEndDate
          )}.`,
          icon: "success",
        });
      } catch (error) {
        console.error("Error:", error.message);
        Swal.fire({
          title: "ERRORE",
          text:
            this.backendMessage(error) ??
            `C'è stato un errore nell'aggiornamento della data di fine fatturazione`,
          icon: "error",
        });
      }
    },
  },
};
</script>

<style scoped>
.warning-text {
  text-align: center;
  font-size: 1rem;
  width: 400px;
}

.data-corrente {
  font-size: 1.8rem;
  font-weight: 600;
  letter-spacing: 1px;
}
</style>
